@for (item of routes | async; track item.name) {
  <div style="margin-left: 0.75rem">
    <a mat-button [routerLink]="item.route" routerLinkActive="sub-active" [routerLinkActiveOptions]="{ exact: item.exactMatch === true }" (click)="itemChanged()">{{ item.name }}</a>
  </div>
}
